<template>
  <div>
    <div
      v-if="
        businessProfile.isBusinessCardDesignAdded == false &&
        businessProfile.isBusinessCardInformationAdded == false
      "
    >
      <div class="text-center">
        <v-icon color="grey lighten-2" size="85">mdi-alert-circle</v-icon>
      </div>
      <div class="mt-2 text-center text--primary text-h6 font-weight-regular">
        Oops, you have not completed your business profile and the branding of
        your card
      </div>
      <div class="text-center my-4">
        <v-btn
          class="pa-5"
          color="primary"
          elevation="0"
          width="220"
          @click="setUpClick"
        >
          Let’s set up
        </v-btn>
      </div>
    </div>
    <div v-else-if="businessProfile.isBusinessCardInformationAdded == false">
      <div class="text-center">
        <v-icon color="grey lighten-2" size="85">mdi-alert-circle</v-icon>
      </div>
      <div class="mt-2 text-center text--primary text-h6 font-weight-regular">
        Oops, you have not completed your business profile
      </div>
      <div class="text-center my-4">
        <v-btn
          class="pa-5"
          color="primary"
          elevation="0"
          width="220"
          @click="setUpClick"
        >
          Complete business profile
        </v-btn>
      </div>
    </div>
    <div v-else-if="businessProfile.isBusinessCardDesignAdded == false">
      <div class="text-center">
        <v-icon color="grey lighten-2" size="85">mdi-alert-circle</v-icon>
      </div>
      <div class="mt-2 text-center text--primary text-h6 font-weight-regular">
        Oops, you have not added branding to your card
      </div>
      <div class="text-center my-4">
        <v-btn
          class="pa-5"
          color="primary"
          elevation="0"
          width="220"
          @click="setUpClick"
        >
          Add branding
        </v-btn>
      </div>
    </div>
    <!-- <AddEditBusinessCardDialog v-model="addEditBusinessCardDialog" /> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import AddEditBusinessCardDialog from "@/components/AddEditBusinessCardDialog";

export default {
  name: "RequiresOnboarding",
  //   components: {
  //     AddEditBusinessCardDialog,
  //   },
  data() {
    return {
      addEditBusinessCardDialog: false,
    };
  },
  computed: {
    ...mapGetters(["businessProfile"]),
  },
  methods: {
    setUpClick() {
      if (this.businessProfile.isBusinessCardInformationAdded == false) {
        this.$router.push("/manageBusinessProfile");
      } else if (this.businessProfile.isBusinessCardDesignAdded == false) {
        // this.addEditBusinessCardDialog = true;
        this.$router.push("cardDesign");
      }
    },
  },
};
</script>